<template>
    <div id="sign-up-page">

        <!-- White Box Section -->
        <section class="section-style margin-top-110">
            <div class="container padding-right-left-0">
                <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Create an account</h1>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8">
                        <sign-up-form></sign-up-form>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import SignUpForm from "../components/forms/SignUpForm/SignUpForm";

    export default {
        components: {SignUpForm},
    }

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>